import { observer } from 'mobx-react';
import i_ from 'i18next';
import React from 'react';
import Chip from '@material-ui/core/Chip';

import TextField from '../commons/TextField';
import SelectField from '../commons/SelectField';
import EditDialog from '../commons/EditDialog';
import { Row, Column } from '../commons/Containers';

import Stores from '../../stores/Stores';
import UIStore from '../../stores/UIStore';

const store = Stores.load('candidato');

class UsuarioEdit extends React.Component {
  componentWillMount() {
    this.cargos = Stores.create('cargo');
    this.cargos.query();
    this.partidos = Stores.create('partido');
    this.partidos.query();
  }

  save = () => {
    if (store.edit.id != null) {
      store
        .save()
        .then(() => UIStore.redo(store))
        .catch(UIStore.saveError);
    } else {
      store
        .create()
        .then(data => {
          if (this.props.onSave) {
            this.props.onSave(data);
          }
        })
        .then(() => UIStore.redo(store))
        .catch(UIStore.saveError);
    }
  };

  render() {
    this.item = store.edit != null ? store.edit : {};
    return (
      <EditDialog
        title={i_.t('candidato.title', {
          context: this.item.id ? 'edit' : 'new',
          label: this.item.nome,
        })}
        opened={store.edit != null}
        onCancel={() => (store.edit = null)}
        onSave={this.save}
      >
        <Row>
          <Column>
            <TextField entity="candidato" field="nome" item={this.item} />

            <SelectField
              entity="candidato"
              field="cargo"
              item={this.item}
              list={this.cargos.list}
              labelFunc={m => m.nome}
            />

            <TextField entity="candidato" field="numero" item={this.item} />

            <SelectField
              entity="candidato"
              field="partido"
              item={this.item}
              list={this.partidos.list}
              labelFunc={partido => (
                <Chip
                  key={partido.id}
                  label={partido.sigla}
                  style={{
                    backgroundColor: partido.cor,
                    fontWeight: 'bold',
                    color: 'white',
                  }}
                />
              )}
            />
          </Column>

          <Column>
            <TextField entity="candidato" field="url" item={this.item} />
            {this.item.url ? (
              <img src={this.item.url} alt="Foto Candidato" />
            ) : this.item.avatar ? (
              <img src={this.item.avatar} alt="Foto Candidato" />
            ) : (
              'Insira o número do registro para foto.'
            )}
          </Column>
        </Row>
      </EditDialog>
    );
  }
}

export default observer(UsuarioEdit);



// WEBPACK FOOTER //
// ./src/components/candidato/Edit.js